export default "__VITE_ASSET__BavOrUyR__"